export const FETCH_PAYMENTS = 'FETCH_PAYMENTS';
